import { configureStore } from '@reduxjs/toolkit';
import imageSlice from './imageSlice';
import annotationSlice from './annotationSlice';
import manMeasurements from './manMeasurements';

export const store = configureStore({
  reducer: {
    images: imageSlice,
    annotations: annotationSlice,
    man_measurements: manMeasurements
  },
});
